import React from 'react';
import SalesOverviewTemplate1 from './SalesOverviewTemplate1';
import SalesOverviewTemplate2 from './SalesOverviewTemplate2';
import SalesOverviewTemplate3 from './SalesOverviewTemplate3';
import { normalizeSalesOverviewTemplate } from '../../../utils/dashboardConfigUtils';

const TEMPLATE_COMPONENTS = {
  template1: SalesOverviewTemplate1,
  template2: SalesOverviewTemplate2,
  template3: SalesOverviewTemplate3,
};

const SalesOverviewRenderer = ({
  template,
  labels,
  data,
  metrics,
  loading,
  compact = false,
  period = 'monthly',
  onPeriodChange,
  showAiAssistant = false,
  onAiAssistantClick,
}) => {
  const resolved = normalizeSalesOverviewTemplate({ template });
  const Component = TEMPLATE_COMPONENTS[resolved] || SalesOverviewTemplate1;

  return (
    <Component
      labels={labels}
      data={data}
      metrics={metrics}
      loading={loading}
      compact={compact}
      period={period}
      onPeriodChange={onPeriodChange}
      showAiAssistant={showAiAssistant}
      onAiAssistantClick={onAiAssistantClick}
    />
  );
};

export default SalesOverviewRenderer;
